export const classes = {
  dialog: 'w-[98vw] max-w-[650px] min-w-[350px]',
  body: 'w-full max-h-[80vh] min-h-[100px] pt-2 pb-12 overflow-auto',
};
